import { render, staticRenderFns } from "./MakbuzIndirView.vue?vue&type=template&id=ee78d536"
import script from "./MakbuzIndirView.vue?vue&type=script&lang=ts"
export * from "./MakbuzIndirView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports